



















































































import { Vue, Component } from 'vue-property-decorator';
import { State, Getter } from 'vuex-class';
import { RootStoreState } from '@/store';
import { SwIconButton } from '@libs/unified-ui-framework/src/shared/sw-icon-button';
import { SwActionBar, SwActionBarItem } from '@libs/unified-ui-framework/src/shared/sw-action-bar';
import { AppConfig } from '../app-config-service';

@Component({
  components: {
    SwIconButton,
    SwActionBar,
    SwActionBarItem,
  },
})
export default class SwAppFooter extends Vue {
  cssPrefix: string = 'sw-app-footer';
  date = new Date();
  dateYear = this.date.getFullYear();
  @State((state: RootStoreState) => (state.CoreStoreModule.appConfig))
  appConfig: AppConfig;

  @Getter
  isAppConfigReady: boolean;

  onClickSocialLink(url: string) {
    window.open(url, '_blank');
  }
}
